import React from 'react'
import { Spin, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeartPulse } from '@fortawesome/free-solid-svg-icons'
import '../style/LoadingOverlay.css'

const { Text } = Typography

const DesktopMedicalHistoryLoadingOverlay = ({ loading, saveLoading, text, icon }) => {
  if (!loading && !saveLoading) return null

  return (
    <div className='desktop-loading-overlay'>
      <div className='desktop-loading-content'>
        <div className='desktop-loading-icon'>{icon || <FontAwesomeIcon icon={faHeartPulse} />}</div>
        <Spin size='large' />
        <Text className='desktop-loading-text'>{text || 'Loading...'}</Text>
      </div>
    </div>
  )
}

export default DesktopMedicalHistoryLoadingOverlay
